import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import { toast } from 'react-toastify';
import environment from '../../../environment';

const GroupSettings = ({ initialData }: any) => {
  const user = useSelector((state: any) => state.user);
  const [form, setForm] = useState<any>(null);
  const [submitted, setSubmitted] = useState(false);

  const isGroupLeader = environment.groupLeaderRoleIds.includes(user?.customerRole?._id || user?.customerRole);

  useEffect(() => {
    if (initialData) {
      setForm({
        id: initialData._id,
        connectMeetLabel: initialData.connectMeetLabel || 'ConnectMeet'
      });
    } else if (!initialData && (user?.groupId?._id || user?.groupId)) {
      getGroupDetail();
    }
  }, [initialData]);

  const getGroupDetail = () => {
    const groupId = user?.groupId?._id || user?.groupId;
    loader(true);
    ApiClient.get('api/group/detail', { id: groupId }).then((res: any) => {
      if (res.success) {
        setForm({
          id: res.data._id,
          connectMeetLabel: res.data.connectMeetLabel || 'ConnectMeet'
        });
      }
      loader(false);
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setSubmitted(true);
    
    loader(true);
    ApiClient.put('api/group/update', form).then((res: any) => {
      if (res.success) {
        toast.success('Group settings updated successfully');
      }
      loader(false);
    });
  };

  if (!isGroupLeader) {
    return null;
  }
  
  if (!form) {
    return <div className="text-center py-4">Loading...</div>;
  }


  return (
    <div className="wrapper_section">
      <h3 className="text-2xl font-semibold text-[#111827] mb-4">Group Settings</h3>
      
      <form onSubmit={handleSubmit}>
        <div className="shadow p-4 rounded-lg">
          <div className="mb-4">
            <label className="block mb-2">ConnectMeet Label</label>
            <p className="text-sm text-gray-500 mb-2">
              Customize the name shown for "ConnectMeet" across your group (e.g., "MeetUp", "Networking Session")
            </p>
            <input
              type="text"
              className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
              value={form.connectMeetLabel}
              onChange={e => setForm({ ...form, connectMeetLabel: e.target.value })}
              placeholder="ConnectMeet"
              required
            />
          </div>
          
          <div className="text-right mt-3">
            <button 
              type="submit"
              className="text-white bg-orange-400 bg-orange-600 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default GroupSettings;
